const initRecoTeaserInstance = (container: HTMLDivElement) => {
  const root = container;
  const autoplayEnabled = root.classList.contains('bc-reco-teaser--autoplay');
  const track = root.querySelector('.js-reco-teaser-track') as HTMLDivElement;
  const navItems = root.querySelectorAll(
    '.js-reco-teaser-nav-item',
  ) as NodeListOf<HTMLDivElement>;
  const items = root.querySelectorAll(
    '.js-reco-teaser-item',
  ) as NodeListOf<HTMLDivElement>;

  const timeoutInMs = 10000; // Timeout for autoplay in milliseconds
  let activeIndex = 0;
  let timeoutId: number | null = null;
  let userInteracted = false;

  const toggleActiveClass = (element: HTMLDivElement, isActive: boolean) => {
    element.classList.toggle('is-active', isActive);
    element.setAttribute('aria-selected', isActive.toString());
  };

  const hideItem = (index: number) => {
    const item = items[index] as HTMLDivElement;
    const navItem = navItems[index] as HTMLDivElement;

    toggleActiveClass(item, false);
    toggleActiveClass(navItem, false);
  };

  const showItem = (index: number) => {
    const item = items[index] as HTMLDivElement;
    const navItem = navItems[index] as HTMLDivElement;

    toggleActiveClass(item, true);
    toggleActiveClass(navItem, true);
  };

  const updateActiveIndex = (index: number) => {
    if (activeIndex !== index) {
      hideItem(activeIndex);
    }

    activeIndex = index;
    showItem(activeIndex);
    track.style.setProperty('--index', activeIndex.toString());

    if (autoplayEnabled && !userInteracted) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        // The modulus operator % is used to ensure that the index wraps around when it reaches the end of the array.
        const nextIndex = (activeIndex + 1) % navItems.length;
        updateActiveIndex(nextIndex);
      }, timeoutInMs);
    }
  };

  const disableAutoplay = () => {
    root.classList.remove('bc-reco-teaser--autoplay');
    if (timeoutId) clearTimeout(timeoutId);
  };

  const handleNavItemClick = (index: number) => {
    userInteracted = true;
    if (autoplayEnabled) disableAutoplay();
    updateActiveIndex(index);
  };

  const setTimeoutProperty = () => {
    // Set --timeout to ensure CSS transition is using same timing as JS
    root.style.setProperty('--timeout', `${timeoutInMs}ms`);
  };

  const init = () => {
    setTimeoutProperty();

    navItems.forEach((navItem, index) => {
      navItem.addEventListener('click', () => handleNavItemClick(index));
    });

    // Set initial active index
    if (navItems[0] && items[0]) {
      updateActiveIndex(0);
    }
  };

  if (navItems.length >= 2) {
    init();
  }
};

// Initialize all instances
export const recoTeaser = () => {
  document.querySelectorAll('.js-reco-teaser').forEach(element => {
    initRecoTeaserInstance(element as HTMLDivElement);
  });
};
